// extracted by mini-css-extract-plugin
export default {"right-slider":"ApiModal_right-slider__JTsTq","sub-header":"ApiModal_sub-header__RNqvK","menu-container":"ApiModal_menu-container__pr7MP"};